module.exports = __webpack_public_path__ + "static/media/video-03-ru.50c57880.webm";